import s from './loader.module.scss';

export const Loader = () => {
  return (
    <div className={s.loaderWrapper}>
      <div className={s.loader}></div>
    </div>
  );
};

export default Loader;
